"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Makes a string's first letter uppercase.
 *
 * @return {string} Original string, but with first letter in upper case.
 */
function upperCaseFirst(str) {
    return str.charAt(0).toUpperCase() + str.substring(1);
}
exports.upperCaseFirst = upperCaseFirst;
/**
 * Returns whether the page is in LTR mode. Defaults to `true` if it can't be computed.
 *
 * @return {boolean} Page's language direction is left-to-right.
 */
function isLTR() {
    var dir = 'ltr';
    if (typeof window !== 'undefined') {
        if (window.getComputedStyle) {
            dir = window.getComputedStyle(document.body, null).getPropertyValue('direction');
        }
        else {
            dir = document.body.currentStyle.direction;
        }
    }
    return dir === 'ltr';
}
exports.isLTR = isLTR;
/**
 * Returns whether or not the current device is an iOS device.
 *
 * @return {boolean} Device is an iOS device (i.e. iPod touch/iPhone/iPad).
 */
function isIOS() {
    if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
        return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    }
    return false;
}
exports.isIOS = isIOS;



//////////////////
// WEBPACK FOOTER
// /Users/alexandre/Documents/web/riberfuso/resources/ng/~/ng-sidebar/lib/utils.js
// module id = ../../../../ng-sidebar/lib/utils.js
// module chunks = 9